import { logger } from "./logger-DmtxRp_g.mjs";

export { logger };